function observeCartChanges(callback) {
    const cartEndpoints = [theme.routes.cart_add_url, theme.routes.cart_update_url, theme.routes.cart_change_url, theme.routes.cart_clear_url];
    new PerformanceObserver(list => {
        list.getEntries().forEach(entry => {
            (entry.initiatorType === "fetch" || entry.initiatorType === "xmlhttprequest") && cartEndpoints.some(endpoint => entry.name.includes(endpoint)) && fetch("/cart.js").then(response => response.json()).then(cart => callback(cart))
        })
    }).observe({
        entryTypes: ["resource"]
    })
}
observeCartChanges(cart => {
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
            bubbles: !0
        }))
}), document.addEventListener("DOMContentLoaded", () => {
    let bunningsProducts = [{
            variantId: "44779468914867",
            title: "Easy Fit Pet Gate | 0.82m W x 0.76m H / White",
            bunningsUrl: "https://www.bunnings.com.au/perma-child-safety-easy-fit-pet-gate_p0879355"
        }, {
            variantId: "42819927998643",
            title: "Baby Gate Extensions / 10cm / White",
            bunningsUrl: "https://www.bunnings.com.au/perma-child-safety-10cm-white-gate-extension_p0095267"
        }, {
            variantId: "42591176360115",
            title: "Ultimate 3-in-1 Playpen Barrier / White",
            bunningsUrl: "https://www.bunnings.com.au/perma-child-safety-white-ultimate-3-in-1-playpen-barrier_p0417784"
        }, {
            variantId: "42591176392883",
            title: "Ultimate 3-in-1 Playpen Barrier / Black",
            bunningsUrl: "https://www.bunnings.com.au/perma-child-safety-black-ultimate-3-in-1-playpen_p0658383"
        }, {
            variantId: "44239405154483",
            title: "Easy Fit Baby Gate / White",
            bunningsUrl: "https://www.bunnings.com.au/perma-child-safety-easy-fit-baby-gate_p0095272"
        }
    ];
    const selectors = [".question-choice_list", "question-button__container", ".question_button", ".navigation-bar__button", ".retake-quiz"];
    function checkQuiz(delay = 1300) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                const shadowHost = document.querySelector("#shadow-quiz");
                if (!shadowHost) {
                    reject(new Error("Shadow host #shadow-quiz not found"));
                    return
                }
                const shadowRoot = shadowHost.shadowRoot;
                if (!shadowRoot) {
                    reject(new Error("Shadow root is not accessible"));
                    return
                }
                resolve(shadowRoot)
            }, delay)
        })
    }
    function checkProductResultCards(delay = 1500) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                const elements = document.querySelector("#shadow-quiz").shadowRoot.querySelectorAll(".slot-variant__container");
                if (elements.length > 0 && Array.from(elements).forEach(slot => {
                        let title = slot.querySelector(".slot-variant__title").textContent.trim(),
                        matchedProduct = bunningsProducts.find(bunningsProduct => bunningsProduct.title === title);
                        if (matchedProduct) {
                            let atcButton = slot.querySelector(".slot-product__button");
                            atcButton.style.display = "none";
                            let buttonParent = atcButton.parentElement;
                            if (!buttonParent.querySelector(".quiz-bunnings-button")) {
                                let bunningsButton = document.createElement("a");
                                bunningsButton.className = "quiz-bunnings-button",
                                bunningsButton.href = matchedProduct.bunningsUrl,
                                bunningsButton.innerHTML = `<img class="quiz-button-bunnings-image" src="${window.theme.bunnings.bunningsImageBackground}"/>`,
                                buttonParent.appendChild(bunningsButton)
                            }
                            resolve(matchedProduct)
                        }
                    }), elements.length === 0) {
                    reject(new Error("No Product Cards found or not in results page."));
                    return
                }
            }, delay)
        })
    }
    async function init() {
        try {
            const titles = await checkQuiz();
            checkBunnings(),
            addEventTriggers()
        } catch (error) {
            addEventTriggers(),
            console.log(error.message)
        }
    }
    async function checkBunnings() {
        try {
            let bunnings = await checkProductResultCards()
        } catch (error) {
            console.log(error.message)
        }
    }
    function addEventTriggers() {
        const shadowHost = document.querySelector("#shadow-quiz"),
        shadowRoot = shadowHost.shadowRoot;
        shadowHost.addEventListener("click", event => {
            checkBunnings()
        })
    }
    init()
});